module.exports = __webpack_public_path__ + "static/media/londre-swimsuit.45fa976c.jpg";